import { Link } from "react-router-dom";
import Seo from "@/lib/Seo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable" description="La page demandée est introuvable." path="/404" />
      <div className="flex min-h-[70vh] flex-col items-center justify-center bg-white px-5 text-center">
        <p className="font-display text-7xl font-extrabold text-gradient-brand">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-brand-blue">Page introuvable</h1>
        <p className="mt-2 max-w-md text-slate-500">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Button asChild className="mt-6 rounded-full bg-brand-red hover:bg-brand-red-light">
          <Link to="/">Retour à l'accueil</Link>
        </Button>
      </div>
    </>
  );
}
